import { render } from "./BigTask.vue?vue&type=template&id=caa00876&scoped=true"
import script from "./BigTask.vue?vue&type=script&lang=js"
export * from "./BigTask.vue?vue&type=script&lang=js"

import "./BigTask.vue?vue&type=style&index=0&id=caa00876&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa00876"]])

export default __exports__